if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      // ============================================
      // PRE-ORDER TAGGING - ADD LINE ITEM PROPERTIES
      // ============================================
      const isPreorder = this.form.dataset.preorder === 'true';
      if (isPreorder) {
        formData.append('properties[_pre-order]', 'true');
        formData.append('properties[Pre-order]', 'This item is available for pre-order');
      }
      // ============================================
      
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // MODIFIED: Wait for cart drawer to actually open before removing loading state
          if (this.cart && !this.error) {
            console.log('🔄 Waiting for cart drawer to open...');
            
            // Use MutationObserver to watch for 'active' class on cart
            const observer = new MutationObserver((mutations) => {
              if (this.cart.classList.contains('active')) {
                console.log('✅ Cart drawer opened!');
                observer.disconnect();
                
                // Remove loading state
                this.submitButton.classList.remove('loading');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                
                if (this.cart.classList.contains('is-empty')) {
                  this.cart.classList.remove('is-empty');
                }
                
                this.submitButton.removeAttribute('aria-disabled');
                
                // Show "Added" confirmation
                const textSpan = this.submitButton.querySelector('span');
                if (textSpan) {
                  const originalText = textSpan.textContent;
                  this.submitButton.classList.add('added');
                  textSpan.textContent = 'Added';
                  
                  setTimeout(() => {
                    this.submitButton.classList.remove('added');
                    textSpan.textContent = originalText;
                  }, 2000);
                }
              }
            });
            
            // Start observing cart element for class changes
            observer.observe(this.cart, {
              attributes: true,
              attributeFilter: ['class']
            });
            
            // Fallback timeout after 3 seconds in case cart doesn't open
            setTimeout(() => {
              observer.disconnect();
              console.log('⏱️ Fallback timeout - removing loading state');
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
              this.submitButton.removeAttribute('aria-disabled');
            }, 3000);
          } else {
            // Error case or no cart drawer - remove loading immediately
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}